<a class="nav-link active" data-toggle="tab" [routerLink]="path" role="tablist"
  >
  <fa-icon icon="{{ icon }}" size="2x"></fa-icon> {{ title }}
  <!-- <i class="material-icons">{{ icon }}</i> {{ title }} -->

</a>
<button _ngcontent-c28="" class="buttonFooterTile" id="new_product" [routerLink]="getNewEntityPath()" *ngIf="newButton">
    Nuevo</button>


<!-- <div _ngcontent-c28="" class="verticalLayout rowAuto buttonTile">
	<div _ngcontent-c28="" class="primaryTile" id="products">
	<div _ngcontent-c28="" class="rowAuto primaryTileIcon">
	<ngwk-icon _ngcontent-c28="" class="rowAuto">
	<div class="baseIcon">
	<i class="alignMiddle oinvfwicons oinvfwicons-stuffIcon">
</i>
</div>
</ngwk-icon>
</div>
<div _ngcontent-c28="" class="rowAuto">
	<span _ngcontent-c28="">
Productos</span>
</div>
</div>
<button _ngcontent-c28="" class="buttonFooterTile" id="new_product">
Nuevo</button>
</div> -->
